import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import Marquees from './Marquees';

// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = "https://spst.in/myapp/api/uploads";

function Home() {

	const [uploads, setUploads] = useState([]);
	const [editId, setEditId] = useState(null);
	const [editName, setEditName] = useState('');

	useEffect(() => {
		fetchUploads();
	}, []);

	const fetchUploads = async () => {
		const res = await axios.get(`${API_BASE}/get.php`);
		setUploads(res.data);
	};

	const handleDelete = async (id) => {
		if (!window.confirm("Delete this record?")) return;
		await axios.post(`${API_BASE}/delete.php`, { id });
		fetchUploads();
	};

	const startEdit = (item) => {
		setEditId(item.id);
		setEditName(item.name);
	};

	const saveEdit = async () => {
		await axios.post(`${API_BASE}/update.php`, { id: editId, name: editName });
		setEditId(null);
		fetchUploads();
	};



	return (
		<div>

			<Slider />
			<div style={{ background: 'orange',padding:'15px' }}>
				<marquee><span style={{fontSize:'15pt',fontFamily:'anek malayalam',color:'black'}}>പുന:പ്രതിഷ്ഠാ വാർഷികം 2026 ജൂൺ 18, 19, 20 (1201 മിഥുനം 4,5,6)</span></marquee>
			</div>

			<div class="booking-container" style={{ marginTop: '50px', marginBottom: '50px' }}>

				{/* <!-- SINGLE DAY --> */}
				<div class="booking-box single">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/2972/2972357.png" alt="Single Day Pooja Booking" />
					</div>
					<h3 className="books-3-ways">Single Day Pooja</h3>
					<p>Book pooja for a specific auspicious day with full temple rituals.</p>
					<div class="infobar">
						<span></span>
					</div>
					<div class="book-btn">
						<a href="https://booking.panchamidevi.in/">
							Book Now <span>➜</span>
						</a>
					</div>

				</div>

				{/* <!-- MULTIPLE DAY --> */}
				<div class="booking-box multiple">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/3652/3652191.png" alt="Multi dy Pooja Booking" />
					</div>
					<h3 className="books-3-ways">Multiple Day Pooja</h3>
					<p>Schedule pooja services for several days or festivals.</p>
					<div class="infobar">
						<span></span>
					</div>
					<div class="book-btn">
						<a href="https://booking.panchamidevi.in/multiple.aspx">
							Book Now <span>➜</span>
						</a>
					</div>

				</div>

				{/* <!-- E-KANIKKA --> */}
				<div class="booking-box ekanikka">
					<div class="icon">
						<img src="https://cdn-icons-png.flaticon.com/512/2331/2331944.png" alt="e-kanikka" />
					</div>
					<h3 className="books-3-ways">E-Kanikka</h3>
					<p>Offer digital donations securely to the deity from anywhere.</p>
					<div class="infobar">
						<span></span>
					</div>
					<div class="book-btn">
						<a href="https://booking.panchamidevi.in/Donation.aspx">
							Donate Now <span>➜</span>
						</a>
					</div>

				</div>

			</div>


			<div className="container" style={{ marginTop: '100px', marginBottom: '100px' }}>
				<div className="row" >

					<div className="col-md-8" style={{ padding: '50px' }}>
						<h1></h1>
						<p class="panchamiabout" >
							ദേശത്തിന്റെ ആത്മചൈതന്യമായി അനുഗ്രഹം ചൊരിഞ്ഞു നിൽക്കുന്ന അമ്മമാരായ ദുർഗ്ഗാദേവിയും വാരാഹി പഞ്ചമിദേവിയും തുല്യപ്രാധാന്യത്തോടെ കുടികൊള്ളുന്ന ശ്രീ പഞ്ചമിദേവി ക്ഷേത്രത്തിന് അഞ്ചുനൂറ്റാണ്ടോളം പഴക്കമുള്ളതായി പറയപ്പെടുന്നു. ആദിപരാശക്തിയായ ദേവിയുടെ സർവ്വസൈന്യാധിപയാണ് സപ്ത‌മാതൃക്കളിൽ അഞ്ചാമത്തേതായ വാരാഹി പഞ്ചമിദേവി. അത്തരത്തിൽ ദുർഗ്ഗാദേവിയും വാരാഹി പഞ്ചമിദേവിയും വലതും ഇടതുമായി ചൈതന്യം ചൊരിഞ്ഞുനിൽക്കുന്ന ക്ഷേത്രം ഒരുപക്ഷേ ലോകത്തിൽതന്നെ മറ്റെങ്ങും ഉണ്ടാകാൻ ഇടയില്ല. വാരാഹി പഞ്ചമിദേവിയെ വൈഷ്‌ണവ-ശൈവ-ശാക്തേയ രീതികളിൽ പൂജിക്കാമെന്ന പ്രത്യേകതയുമുണ്ട്.
							തെക്കത് സമ്പ്രദായത്തിലാണ് ആദ്യകാലത്ത് ദേവിയെ ആരാധിച്ചു വന്നത്. പീഠവും വാളുമായിരുന്നു അന്നത്തെ പ്രതിഷ്ഠ. വർഷത്തിൽ ഒരു ദിവസം നടക്കുന്ന കൊടുതി (ഉത്സവം) അക്കാലത്ത് ഒരു സമൂഹത്തിന്റെയാകെ കൂട്ടായ്‌മ വിളംബരം ചെയ്യുന്നതായിരുന്നു. കൊടുതിയുടെ അന്ന് ഉച്ചയ്ക്ക് നടക്കുന്ന പന്തിരുനാഴിപൂജയായിരുന്നു പ്രധാന വഴിപാട്.
						</p>
					</div>
					<div className="col-md-4" style={{ border: '1px solid silver', padding: '5px', borderRadius: '10px', backgroundImage: 'url(./images/bg.jpeg)', backgroundSize: 'cover', backgroundPosition: 'center' }}>
						{/* <a href="https://online.flippingbook.com/view/731958213/" target="blank"><img src="./images/maholsavam.png" alt="Panchami Devi" style={{width:'100%'}} /></a> */}
						{/* <Rightside />		 */}
					</div>

				</div>
			</div>


			<div class="grouped_sections" style={{ backgroundImage: 'url(./images/img-12.png)', backgroundSize: 'cover', backgroundAttachment: 'fixed', backgroundPosition: 'center' }}>

				<div class="container">
					<div class="row">

						{/* <!-- Why Choose Us --> */}


					</div>
				</div>
			</div>

			{/* <div class="container" style={{paddingTop:'75px', paddingBottom:'75px'}}>
		<div class="row">
			<div class="col-md-5">
				<div className="fund">
					<img src="./images/suvarnadarsan.png" alt="Suvarna Darsanam" style={{width:'100%',borderRadius:'15px'}} />
					<center><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=75" className="btn btn-primary" style={{width:'150px',background:'orange',color:'maroon',border:'none',fontSize:'14pt',fontWeight:'700',marginTop:'15px'}}>Book </Link></center>
				</div>
			</div>
			<div class="col-md-7">
				<div className="fund">
					<img src="./images/bhadratha.png" alt="Suvarna Darsanam" style={{width:'100%',borderRadius:'15px'}} />
					<center><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=72" className="btn btn-primary" style={{width:'150px',background:'orange',color:'maroon',border:'none',fontSize:'14pt',fontWeight:'700',marginTop:'15px'}}>Book </Link></center>
				</div>
			</div>
		</div>
	</div> */}
			{/* <div className="gosala">
			<div className="overlay">
				<div class="gosaladonate">
					<Link to="https://booking.sreepadmanabhaswamytemple.org/Murajepam.aspx" className="btn btn-primary" style={{padding:'20px',background:'orange',color:'maroon',fontSize:'14pt',fontWeight:'400',border:'1px solid orange'}}>Goshala Donation</Link>
					<Link to="https://booking.sreepadmanabhaswamytemple.org/GoldenGrace.aspx" className="btn btn-primary" style={{padding:'20px',background:'orange',color:'maroon',fontSize:'14pt',fontWeight:'400',border:'1px solid orange'}}>Donate Golden Grace & Grandeur</Link>
				</div>
			</div>
	</div> */}




		</div>

	);
}

export default Home;